<div class="bn-app-shield-event-logs-search">
  <app-app-shield-event-logs-toolbar
    class="bn-app-shield-event-logs-search__toolbar"
    [chipsConfig]="chipsConfig()"
    [chipsValue]="chipsValue()"
    [from]="store.from()"
    [groupByDims]="store.groupByDims()"
    [hasLogs]="store.total() > 0"
    [isExporting]="isExporting()"
    [isLoading]="isSearching()"
    [query]="store.query()"
    [to]="store.to()"
    (dateRangeChange)="onDateRangeChange($event)"
    (exportClicked)="store.exportCsv()"
    (filtersChange)="onFiltersChange($event)"
    (groupByChange)="store.setGroupBy($event)"
    (queryChange)="store.setQuery($event)"
    (refreshClicked)="store.refresh()" />

  @if (store.isGrouped()) {
    <app-app-shield-event-logs-groups-table
      [expandedGroupRows]="store.expandedGroupRows()"
      [groups]="store.groups()"
      [isLoading]="isSearching()"
      (groupPageChange)="store.loadGroupRows($event)"
      (groupToggled)="store.loadGroupRows({ group: $event, page: 0 })" />
  } @else {
    <app-app-shield-event-logs-table
      [isLoading]="isSearching()"
      [rows]="store.rows()" />
  }

  @if (store.total() > 0) {
    <bn-web-ui-pagination
      [settings]="{ currentPage: store.page() + 1, perPage: store.pageSize(), queryParamEnabled: false, totalItems: store.total() }"
      (page)="onPageChange($event)" />
  }
</div>
